import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from 'src/app/services/admin/admin.service';
import { forkJoin } from 'rxjs';
import { StateModel } from 'src/app/core/StateModel';
@Component({
  selector: 'app-x-short-course-list',
  templateUrl: './x-short-course-list.component.html',
  styleUrl: './x-short-course-list.component.scss'
})
export class XShortCourseListComponent {

  // Store selected course type from URL
  courseType: string = '';


  // Store all UOC courses
  allUOCCourses: any[] = [];

  // Store all VOC courses
  allVOCCourses: any[] = [];

  // Store displayed course list
  courses: any[] = [];

  // Track loading state
  isLoading: boolean = false;


  // ============================================================
  // ALL COURSES PAGE SECTIONS
  // ============================================================

  // Store active all courses section
  activeAllCoursesSection: 'POPULAR' | 'OTHER' = 'POPULAR';

  // Store other course options
  otherCourseOptions: string[] = ["001-TEST-COURSE"];

  // Store selected other course
  selectedOtherCourse = '';

  // Store custom other course
  customOtherCourse = '';

  // Store enquiry name
  otherEnquiryName = '';

  // Store enquiry email
  otherEnquiryEmail = '';

  // Store enquiry phone
  otherEnquiryPhone = '';

  // Store enquiry message
  otherEnquiryMessage = '';

  // Track other enquiry submission
  isSendingOtherEnquiry = false;

  // Store other enquiry error message
  otherEnquiryErrorMessage = '';

  // Store other enquiry success message
  otherEnquirySuccessMessage = '';

  // Store current page
  currentPage: number = 1;

  // Store page size
  pageSize: number = 8;

  // Control enquiry success popup visibility
  showEnquirySuccessPopup: boolean = false;

  //store search keyword
  searchKeyword: string = "";

  //store selected course filter
  selectedCourseFilter: string = '';

  //store short course options list
  shortCourseOptions: any[] = [];

  //store main component
  isMainComponent: boolean = false;

  //store states list 
  statesList: StateModel[] = [];

  //store form state code
  selectedShortCourseStateCode: string = '';
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private adminService: AdminService
  ) {
  }


  // Initialise course list
  ngOnInit(): void {



    // Read route query parameters
    this.route.queryParamMap.subscribe(params => {

      // Check if the URL path is /course-short
      this.isMainComponent = this.router.url.split('?')[0] === '/course-short';

      // Store course type from URL
      this.courseType = (params.get('type') ?? 'ALL').toUpperCase();



      // Reset current page
      this.currentPage = 1;

      // Set default all courses section
      this.activeAllCoursesSection = 'POPULAR';

      // Load all courses
      if (this.courseType === 'ALL' || this.courseType === 'ALL_COURSES') {

        this.searchKeyword =
          params.get('searchKey') ?? '';

        this.selectedCourseFilter =
          params.get('search') ?? '';

        this.selectedShortCourseStateCode = (params.get('state_code') ?? 'mel').toUpperCase();

        this.searchShortCourses();

      } else if (this.courseType === 'VOC' || this.courseType === 'voc') {

        // Load VOC courses
        this.loadVOCCourses();

      } else if (this.courseType === 'ALL_SHORT_COURSES') {
        this.searchKeyword = params.get('searchKey') ?? '';

        this.selectedShortCourseStateCode = (params.get('state_code') ?? 'mel').toUpperCase();

        this.selectedCourseFilter =
          params.get('search') ?? '';
        // Load short courses by type
        this.loadShortCourses('all_courses');

      } else if (this.courseType === 'SS') {
        this.selectedShortCourseStateCode = (params.get('state_code') ?? 'mel').toUpperCase();
        this.loadSkillSetsCourses(this.courseType);
      } else {

        // Load short courses by type
        this.loadShortCourses(this.courseType);

      }

    });

    this.loadStates();

  }


  loadStates(): void {

    this.adminService.getStatesService('ALL_ACTIVE').subscribe({
      next: (response: StateModel[]) => {
        this.statesList = response || [];
        this.loadDropdownUOCCourses();
      },
      error: error => {
        console.error('Failed to load states:', error);
        this.statesList = [];
      }
    });

  }
  onShortCourseStateChange(stateCode: string): void {
    this.selectedShortCourseStateCode = stateCode;
    const selectedState = this.statesList.find(
      x => x.code === stateCode
    );
    this.loadDropdownUOCCourses();
    this.searchShortCourses();
  }

  // Load all courses
  loadAllCourses(): void {

    // Start loading
    this.isLoading = true;

    // Load UOC and VOC courses
    forkJoin({

      uoc: this.adminService
        .GetXCourseListByType('GET_BY_TYPE', 'ALL', this.searchKeyword, this.selectedCourseFilter, true),

      voc: this.adminService.getXVOCList('GET_ALL')

    }).subscribe({

      next: (response: any) => {

        // Store UOC courses
        this.allUOCCourses =
          (response.uoc || []).map((course: any) => ({
            ...course,
            courseType: 'UOC'
          }));

        // Store VOC courses
        this.allVOCCourses =
          (response.voc || [])
            .filter((course: any) =>
              (course.isActive ?? course.IsActive ?? true) === true
            )
            .map((course: any) => ({
              ...course,
              courseType: 'VOC'
            }));

        // Merge both course lists
        this.courses = [
          ...this.allUOCCourses,
          ...this.allVOCCourses
        ];


        // Stop loading
        this.isLoading = false;
      },

      error: (error) => {

        // Log all courses error
        console.error(
          'All Courses Error:',
          error
        );

        // Reset course lists
        this.allUOCCourses = [];
        this.allVOCCourses = [];
        this.courses = [];

        // Stop loading
        this.isLoading = false;
      }

    });

  }



  // ============================================================
  // LOAD UOC COURSES
  // ============================================================

  loadDropdownUOCCourses(): void {

    this.shortCourseOptions = []
    this.adminService
      .getXCourseList('GET_ALL', this.selectedShortCourseStateCode)
      .subscribe({
        next: (response: any[]) => {
          this.shortCourseOptions = response || [];
        },
        error: (error) => {
          console.error(
            'Error loading UOC courses:',
            error
          );
        }
      });


  }


  searchShortCourses(): void {
    // Set current page
    this.currentPage = 1;

    if (this.courseType === 'ALL' || this.courseType === 'ALL_COURSES') {
      this.loadShortCourses('ALL_COURSES');
    } else if (this.courseType === 'ALL_SHORT_COURSES') {
      // Load short courses by type
      this.loadShortCourses('all_courses');
    } else {
      this.loadShortCourses('UOC');
    }

  }

  // Load short courses
  loadSkillSetsCourses(type: string): void {

    // Start loading
    this.isLoading = true;
    this.allUOCCourses = [];
    this.adminService
      .GetXCourseListByType('GET_SKILL_BY_TYPE', type, this.searchKeyword, this.selectedCourseFilter, true, this.selectedShortCourseStateCode)
      .subscribe({
        next: (response: any[]) => {

          // Store UOC courses
          this.allUOCCourses =
            response || [];

          /*
            If you only want active courses:
            
            this.courses = this.allUOCCourses.filter(
              x => x.isActive === true
            );
  
            For now all returned courses are shown.
          */

          // Store displayed courses
          this.courses =
            this.allUOCCourses;

          // Stop loading
          this.isLoading = false;
        },

        error: (error) => {

          // Log UOC error
          console.error(
            'UOC Error:',
            error
          );

          // Reset displayed courses
          this.courses = [];

          // Stop loading
          this.isLoading = false;
        }

      });

  }


  // Load short courses
  loadShortCourses(type: string): void {

    // Start loading
    this.isLoading = true;
    this.allUOCCourses = [];
    this.adminService
      .GetXCourseListByType('GET_BY_TYPE', type, this.searchKeyword, this.selectedCourseFilter, true, this.selectedShortCourseStateCode)
      .subscribe({
        next: (response: any[]) => {

          // Store UOC courses
          this.allUOCCourses =
            response || [];

          /*
            If you only want active courses:
            
            this.courses = this.allUOCCourses.filter(
              x => x.isActive === true
            );
  
            For now all returned courses are shown.
          */

          // Store displayed courses
          this.courses =
            this.allUOCCourses;

          // Stop loading
          this.isLoading = false;
        },

        error: (error) => {

          // Log UOC error
          console.error(
            'UOC Error:',
            error
          );

          // Reset displayed courses
          this.courses = [];

          // Stop loading
          this.isLoading = false;
        }

      });

  }


  // Load VOC courses
  loadVOCCourses(): void {

    // Start loading
    this.isLoading = true;

    this.adminService
      .getXVOCList('GET_ALL')
      .subscribe({

        next: (response: any[]) => {

          // Store VOC courses
          this.allVOCCourses =
            response || [];

          // Store displayed courses
          this.courses =
            this.allVOCCourses;

          // Stop loading
          this.isLoading = false;
        },

        error: (error) => {

          // Log VOC error
          console.error(
            'VOC Error:',
            error
          );

          // Reset displayed courses
          this.courses = [];

          // Stop loading
          this.isLoading = false;
        }

      });

  }
  // Get course code
  getCourseCode(course: any): string {

    // Get course type
    const type =
      this.courseType === 'ALL'
        ? course?.courseType
        : this.courseType;

    // Return VOC code
    if (type === 'VOC') {
      return 'VOC - ' + course?.vocCode || 'VOC';
    }

    // Return UOC code
    return course?.courseCode || 'UOC';
  }


  // Get course type only
  getCourseCodeOnly(course: any): string {

    // Get course type
    const type =
      this.courseType === 'ALL'
        ? course?.courseType
        : this.courseType;

    // Return course type
    return type;
  }


  // ============================================================
  // COURSE TITLE
  // ============================================================

  // Get course title
  getCourseTitle(course: any): string {

    // Get course type
    const type =
      this.courseType === 'ALL'
        ? course?.courseType
        : this.courseType;

    // Return VOC title
    if (type === 'VOC') {
      return course?.vocName || 'VOC';
    }

    // Return UOC title
    return course?.courseTitle || '';
  }


  // ============================================================
  // COURSE DESCRIPTION
  // ============================================================

  // Get course description
  /*  getCourseDescription(course: any): string {
  
    if (
      course?.description &&
      course.description.trim().length > 0
    ) {
  
      const plainText =
        course.description
          .replace(/<[^>]*>/g, '')
          .trim();
  
      if (plainText.length > 100) {
        return plainText.substring(0, 100) + '...';
      }
  
      return plainText;
    }
  
    return '-';
  } */
  /* getCourseDescription(course: any): string {
  
      // Check course description
      if (
        course?.description &&
        course.description.trim().length > 0
      ) {
  
        return course.description;
      }
  
      // Return default description
      return '-';
    } */
  getCourseDescription(course: any): string {

    if (
      !course?.description ||
      course.description.trim().length === 0
    ) {
      return '-';
    }

    const maxLength = 80;

    const container =
      document.createElement('div');

    container.innerHTML =
      course.description;

    let currentLength = 0;
    let isTruncated = false;


    const truncateNode = (
      node: Node
    ): Node | null => {

      // Text node
      if (
        node.nodeType === Node.TEXT_NODE
      ) {

        const text =
          node.textContent || '';

        const remaining =
          maxLength - currentLength;

        if (remaining <= 0) {
          isTruncated = true;
          return null;
        }

        if (text.length > remaining) {

          currentLength += remaining;
          isTruncated = true;

          return document.createTextNode(
            text.substring(0, remaining)
          );
        }

        currentLength +=
          text.length;

        return document.createTextNode(
          text
        );
      }


      // HTML element
      if (
        node.nodeType === Node.ELEMENT_NODE
      ) {

        const clonedElement =
          (node as HTMLElement)
            .cloneNode(false) as HTMLElement;

        for (
          const child of Array.from(node.childNodes)
        ) {

          if (currentLength >= maxLength) {
            isTruncated = true;
            break;
          }

          const clonedChild =
            truncateNode(child);

          if (clonedChild) {
            clonedElement.appendChild(
              clonedChild
            );
          }
        }

        return clonedElement;
      }


      return null;
    };


    const result =
      document.createElement('div');


    for (
      const child of Array.from(container.childNodes)
    ) {

      if (currentLength >= maxLength) {
        isTruncated = true;
        break;
      }

      const clonedChild =
        truncateNode(child);

      if (clonedChild) {
        result.appendChild(
          clonedChild
        );
      }
    }


    // Add ... inside the last text node
    if (isTruncated) {

      const addEllipsis = (
        node: Node
      ): boolean => {

        const children =
          Array.from(node.childNodes)
            .reverse();

        for (
          const child of children
        ) {

          if (
            child.nodeType === Node.TEXT_NODE &&
            child.textContent?.trim()
          ) {

            // Remove existing trailing dots first
            const text =
              child.textContent
                .replace(/[\s.…]+$/, '');

            child.textContent =
              text + '...';

            return true;
          }

          if (
            child.nodeType === Node.ELEMENT_NODE
          ) {

            if (addEllipsis(child)) {
              return true;
            }
          }
        }

        return false;
      };


      addEllipsis(result);
    }


    return result.innerHTML;
  }
  // ============================================================
  // COURSE IMAGE
  // ============================================================

  // Check course image
  hasCourseImage(course: any): boolean {

    return !!(
      course?.imageUrl &&
      course.imageUrl.trim().length > 0 &&
      !course.imageLoadFailed
    );
  }


  // Handle broken image
  onImageError(course: any): void {

    // Mark image load failure
    course.imageLoadFailed = true;
  }

  // Check course price availability
  hasPrice(course: any): boolean {

    return (
      (this.courseType === 'UOC' ||
        this.courseType === 'OSC' ||
        this.courseType === 'HRC') &&
      Number(course?.totalAmount ?? 0) > 0
    );
  }


  // Get course price
  getPrice(course: any): string {

    // Check price availability
    if (!this.hasPrice(course)) {

      return 'Enquire for pricing';
    }

    // Store currency code
    const currency =
      course?.currencyCode || 'AUD';

    // Format course price
    return new Intl.NumberFormat(
      'en-AU',
      {
        style: 'currency',
        currency: currency
      }
    ).format(
      Number(course.totalAmount)
    );
  }


  // Open course details
  openCourseDetails(course: any): void {


    // Read route query parameters
    this.route.queryParams.subscribe(params => {

      // Get current route with query parameters
      const currentUrl = this.router.url;

      // Store current URL in local storage
      localStorage.setItem(
        'PREVIOUS_COURSE_URL',
        currentUrl
      );

    });

    // Check course ID
    if (!course?.id) {
      return;
    }

    // Get course type
    const type = this.getCourseCodeOnly(course);

    // Navigate to course details
    this.router.navigate(
      ['/short-details'],
      {
        queryParams: {

          type: type?.toLowerCase(),

          id: course.id
        }
      }
    );
  }


  // Get paginated courses
  get paginatedCourses(): any[] {

    // Calculate start index
    const startIndex =
      (this.currentPage - 1) *
      this.pageSize;

    // Calculate end index
    const endIndex =
      startIndex +
      this.pageSize;

    // Return paginated course list
    return this.courses.slice(
      startIndex,
      endIndex
    );
  }

  // Get total page count
  get totalPages(): number {

    // Check course list
    if (!this.courses.length) {
      return 0;
    }

    // Calculate total pages
    return Math.ceil(
      this.courses.length /
      this.pageSize
    );
  }


  // Get page numbers
  get pages(): number[] {

    return Array.from(
      {
        length: this.totalPages
      },
      (_, index) => index + 1
    );
  }


  // Go to selected page
  goToPage(page: number): void {

    // Validate page number
    if (
      page < 1 ||
      page > this.totalPages
    ) {
      return;
    }

    // Set current page
    this.currentPage = page;

    // Get course list section
    const section =
      document.getElementById(
        'short-course-list'
      );

    // Scroll to course list
    if (section) {

      section.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }


  // Go to previous page
  previousPage(): void {

    this.goToPage(
      this.currentPage - 1
    );
  }


  // Go to next page
  nextPage(): void {

    this.goToPage(
      this.currentPage + 1
    );
  }


  // Select all courses section
  selectAllCoursesSection(section: 'POPULAR' | 'OTHER'): void {

    // Set active section
    this.activeAllCoursesSection = section;

    // Reset enquiry messages
    this.otherEnquiryErrorMessage = '';
    this.otherEnquirySuccessMessage = '';
  }


  // Handle other course selection
  onOtherCourseSelectionChange(): void {

    // Reset custom course when not selected
    if (this.selectedOtherCourse !== 'OTHER') {
      this.customOtherCourse = '';
    }

    // Reset enquiry messages
    this.otherEnquiryErrorMessage = '';
    this.otherEnquirySuccessMessage = '';
  }


  // Get requested other course name
  get requestedOtherCourseName(): string {

    // Return custom course name
    if (this.selectedOtherCourse === 'OTHER') {
      return this.customOtherCourse?.trim() || '';
    }

    // Return selected course name
    return this.selectedOtherCourse?.trim() || '';
  }


  // Validate other course enquiry
  validateOtherCourseEnquiry(): boolean {

    // Reset enquiry error
    this.otherEnquiryErrorMessage = '';

    // Validate course selection
    if (!this.selectedOtherCourse) {

      this.otherEnquiryErrorMessage =
        'Please select a course, or choose Other to enter a course.';

      return false;
    }

    // Validate custom course name
    if (
      this.selectedOtherCourse === 'OTHER' &&
      !this.customOtherCourse?.trim()
    ) {

      this.otherEnquiryErrorMessage =
        'Please enter the course you would like to enquire about.';

      return false;
    }

    // Validate enquiry name
    if (!this.otherEnquiryName?.trim()) {

      this.otherEnquiryErrorMessage =
        'Please enter your name.';

      return false;
    }

    // Validate enquiry email
    if (!this.otherEnquiryEmail?.trim()) {

      this.otherEnquiryErrorMessage =
        'Please enter your email address.';

      return false;
    }

    // Store email validation pattern
    const emailPattern =
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    // Validate email format
    if (
      !emailPattern.test(
        this.otherEnquiryEmail.trim()
      )
    ) {

      this.otherEnquiryErrorMessage =
        'Please enter a valid email address.';

      return false;
    }

    // Validate telephone number
    if (!this.otherEnquiryPhone?.trim()) {

      this.otherEnquiryErrorMessage =
        'Please enter your contact telephone number.';

      return false;
    }

    return true;
  }


  // Close enquiry success popup
  closeEnquirySuccessPopup(): void {

    // Hide success popup
    this.showEnquirySuccessPopup = false;

    // Navigate to home page
    this.router.navigate(['/']);
  }



  // Send other course enquiry
  sendOtherCourseEnquiry(): void {

    // Reset enquiry messages
    this.otherEnquirySuccessMessage = '';
    this.otherEnquiryErrorMessage = '';

    // Validate enquiry details
    if (!this.validateOtherCourseEnquiry()) {
      return;
    }

    // Create enquiry JSON
    const enquiryJson = {
      enquiryType: 'OTHER_COURSE_ENQUIRY',
      clientType: 'OTHER_COURSE_ENQUIRY',

      course: {
        selection: this.selectedOtherCourse === 'OTHER' ? 'OTHER' : 'LISTED_COURSE',
        courseName: this.requestedOtherCourseName
      },

      contactDetails: {
        name: this.otherEnquiryName.trim(),
        email: this.otherEnquiryEmail.trim(),
        telephone: this.otherEnquiryPhone.trim()
      },

      message: this.otherEnquiryMessage?.trim() || '',
      createdDate: new Date().toISOString()
    };

    // Create enquiry model
    const enquiryModel = {
      id: 0,
      body: JSON.stringify(enquiryJson),
      sentBy: this.otherEnquiryEmail.trim(),
      reviewedBy: null,
      reviewedDate: null,
      isApproved: false,
      isActive: true,
      clientType: 'OTHER_COURSE_ENQUIRY'
    };

    // Start enquiry submission
    this.isSendingOtherEnquiry = true;

    // Submit enquiry
    this.adminService.setXEnquiry(enquiryModel, 'INSERT').subscribe({

      next: (response: any) => {

        console.log(
          'Other Course Enquiry Response:',
          response
        );

        // Show success popup
        this.showEnquirySuccessPopup = true;

        // Stop enquiry submission
        this.isSendingOtherEnquiry = false;

        // Store success message
        this.otherEnquirySuccessMessage =
          'Your course enquiry has been sent successfully.';

        // Reset enquiry form
        this.selectedOtherCourse = '';
        this.customOtherCourse = '';
        this.otherEnquiryName = '';
        this.otherEnquiryEmail = '';
        this.otherEnquiryPhone = '';
        this.otherEnquiryMessage = '';
      },

      error: (error: any) => {

        console.error(
          'Other Course Enquiry Error:',
          error
        );

        // Stop enquiry submission
        this.isSendingOtherEnquiry = false;

        // Store enquiry error
        this.otherEnquiryErrorMessage =
          'Unable to send your enquiry. Please try again.';
      }
    });
  }
}